import { gql } from '@apollo/client';
import { Role } from 'auth';
export interface UserRole {
  type: Role;
  organizationId: string;
  userId: string;
  personId: string;
  scopeId: string;
  scopeType: string;
  permissions: Array<string>;
}
export interface Data {
  id: string;
  isAdmin: boolean;
  isLabRat: boolean;
  firstName: string;
  lastName: string;
  email: string;
  personUuid: string;
  uciUuid: string;
  activeTeamCount: number;
  managedDivisionCount: number;
  managedTeamIds: number[];
  roles: Array<UserRole>;
}

export const QUERY = gql`
  query ShowUser {
    user {
      id
      isAdmin
      isLabRat
      firstName
      lastName
      email
      personUuid
      uciUuid
      activeTeamCount
      managedDivisionCount
      managedTeamIds
      roles {
        id
        type
        scopeType
        scopeId
        organizationId
        permissions
        isTsSupportAdmin
      }
    }
  }
`;
